import React from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ListOfProducts from '../productsList';

const ProductAccordionList = ({ productsGrouped = [], setSelected }) => {

    if (productsGrouped.length === 0) {
        return null;
    }

    const createSecondary = (prod) => prod.ingredients;

    return (
        <div style={{width: '100%'}}>
            {productsGrouped.map(group => (
                <Accordion key={group.id} style={{width: '100%'}}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`panel-${group.id}-content`}
                        id={`panel-${group.id}-header`}
                    >
                        <Typography>{group.name}</Typography>
                    </AccordionSummary>
                    <AccordionDetails style={{width: '100%', padding: 0}}>
                        <ListOfProducts
                            items={group.products}
                            createSecondary={createSecondary}
                            setSelected={setSelected}
                        />
                    </AccordionDetails>
                </Accordion>
            ))}
        </div>
    );
};

export default ProductAccordionList;
